module.exports = __webpack_public_path__ + "static/media/space-food_006.5a56081b.jpg";